import styled from "styled-components";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const PricesWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
`;

export const Price = styled.span``;

export const Discount = styled.span`
    background-color: ${theme.colors.midnight};
`;

export const LineThrough = styled.span`
    text-decoration: line-through;
`;
